import { Routes } from '@angular/router';
import { LoginComponent } from '@common/components/login/login.component';
import { LogoutComponent } from '@common/components/logout.component';
import { UnauthorizedComponent } from '@common/components/unauthorized.component';
import { AuthGuard } from '@common/guards/auth.guard';
import { AppSettings, checkFeatureAvailabilityGuard } from '@common/guards/check-feature-availability.guard';

export const ROUTES: Routes = [
    { path: 'login', component: LoginComponent },
    { path: '401', component: UnauthorizedComponent },
    { path: 'logout', component: LogoutComponent },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            { path: '', redirectTo: '/home', pathMatch: 'full' },
            {
                path: 'administration',
                loadChildren: () =>
                    import('./administration/administration.routes').then((m) => m.ADMINISTRATION_ROUTES),
                data: { title: 'Administration' }
            },
            { path: 'home', loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent) },
            {
                path: 'user-account',
                loadChildren: () => import('./user-account/user-account.routes').then((m) => m.USER_PROFILE_ROUTES),
                data: { title: 'Account' }
            },
            {
                path: 'notice-board',
                loadChildren: () => import('./notice-board/notice-board.routes').then((m) => m.NOTICE_BOARD_ROUTES),
                canActivate: [checkFeatureAvailabilityGuard],
                data: { title: 'Notifications', check: AppSettings.NoticeBoard }
            },
            {
                path: 'user-settings',
                loadChildren: () => import('./user-settings/user-settings.routes').then((m) => m.USER_SETTINGS_ROUTES),
                data: { title: 'User Settings' }
            },
            {
                path: 'faq',
                loadChildren: () => import('./faq/faq.routes').then((m) => m.FAQ_ROUTES),
                data: { title: 'FAQ' }
            },
            { path: '**', redirectTo: '/home' }
        ]
    }
];
